import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";
import { useNavigate } from "react-router-dom";

export default function UpdateValueSadaad({
  list,
  PopUp,
  setPopUp,
  url,
  title,
  setTrigger,
  trigger,
  isRenwal,
  apiCall,
}) {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  console.log("list to be printed here in the console", list);

  const [file, setFile] = useState();

  // const dropDownData = [
  //   "3 MONTHS",
  //   "6 MONTHS",
  //   "9 MONTHS",
  //   "12 MONTHS",
  //   "15 MONTHS",
  //   "18 MONTHS",
  //   "21 MONTHS",
  //   "24 MONTHS",
  //   "27 MONTHS",
  //   "30 MONTHS",
  //   "33 MONTHS",
  //   "36 MONTHS",
  // ];

  const dropDownData = [
    "90 Days",
    "180 Days",
    "270 Days",
    "360 Days",
    "450 Days",
    "540 Days",
    "630 Days",
    "720 Days",
    "810 Days",
    "900 Days",
    "990 Days",
    "1080 Days",
  ];
  console.log("log to be seen in the console", list);
  var length = list.length;
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState(null);

  const [terms, setTerms] = useState("");

  const handleStatusChange = (e) => {
    setTerms(e.target.value);
  };

  const handleInputChange = (event) => {
    // if (event.target.value.length < 14 || event.terget.value > 16) {
    setInputValue(event.target.value);
    console.log(event.target.value);
  };

  const token = localStorage.getItem("nodeToken");

  const update = async (e) => {
    e.preventDefault();

    if ((!isRenwal && terms === "") || terms === undefined) {
      dispatch(
        setAppError({
          msg: "Saddad terms are required",
        })
      );
      return;
    }
    // if (inputValue.length < 14 || inputValue.length > 16) {
    //   dispatch(
    //     setAppError({
    //       msg: "Sadaad Number should be between 14 to 16 digits.",
    //     })
    //   );
    //   return;
    // }
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("file", file); // ✅ should now contain the File object
      formData.append("employeeId", list); // If list is an object, consider using JSON.stringify
      formData.append("sadaadNumber", inputValue);
      formData.append("terms", terms);
      formData.append("isRenwal", isRenwal);

      // Optional: Debug check
      // for (let pair of formData.entries()) {
      //   console.log(pair[0] + ':', pair[1]);
      // }

      const response = await nodeinstance.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          // No need to set Content-Type manually for FormData
        },
      });

      if (response.status === 200) {
        console.log("respone print", response);
        if (response.data.status === false) {
          dispatch(
            setAppError({
              msg: "Sadaad Number alreday issued",
              // color: "success",
            })
          );
          setLoading(false);
          return;
        } else if (response.data.length <= 0) {
          navigate(`/dashboard/fin-sadaad`);
        }
        dispatch(
          setAppError({
            msg:
              response.data.length > 0
                ? response?.data[0]?.messege
                : "Updated successfully",
            color: "success",
          })
        );
        setPopUp(false);
        setLoading(false);
        setTrigger(!trigger);
        if (apiCall) apiCall();
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        setAppError({
          msg: error?.response?.data?.error || "Something went wrong",
        })
      );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form onSubmit={(e) => update(e, file)} className="w-full">
            <div className="w-full">
              <div className="w-full flex flex-col gap-3 my-3 p-5">
                <div className="form-control w-full place-items-center">
                  <h2 className="label place-items-center">{title}</h2>
                </div>

                <div className="flex flex-row">
                  <h2 className="label place-items-center">
                    Total Selected Count
                  </h2>
                  <h2 className="label place-items-center font-bold">
                    {length}
                  </h2>
                </div>

                <div className="flex row-span">
                  <h2 className="label place-items-center p-1">
                    <span className="label-text">ENTER Sadaad TERMS</span>
                  </h2>
                  <select
                    className="border-[1px] border-border dark:bg-dark rounded-md p-10 py-2 text-xs ml-2"
                    onChange={(e) => handleStatusChange(e)}
                    disabled={isRenwal}
                  >
                    <option value="">SELECT STATUS</option>
                    {dropDownData.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex row-span">
                  <h2 className="label place-items-center p-1">
                    <span className="label-text">Enter Sadaad Number</span>
                  </h2>
                  <input
                    type="text"
                    defaultValue={list.border_number}
                    className="w-48 input input-sm input-bordered"
                    required
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>

                <div>
                  <input
                    type="file"
                    className="file-input file-input-bordered w-medium"
                    onChange={(e) => setFile(e.target.files[0])} // ✅ fixed
                    accept="image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  />
                  <h1 style={{ color: "blue" }} className="mt-2">
                    * File format should be SADAADNUMBER.PDF
                  </h1>
                </div>

                <div
                  className="flex gap-3 w-full justify-center"
                  style={{ margin: 2 }}
                >
                  <button
                    type="submit"
                    className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                  >
                    <p>Submit</p>
                    {loading ? <CgSpinner className="animate-spin" /> : ""}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
